export const getTitleText = (
  value: string,
  stats: {
    entitlementCount: number;
    accountCount: number;
    violationCount: number;
  }
) => {
  if (value === 'entitlement') {
    if (stats.entitlementCount === 0) {
      return 'Entitlements';
    }

    if (stats.entitlementCount === 1) {
      return '1 Entitlement';
    }

    return `${stats.entitlementCount} Entitlements`;
  }

  if (value === 'account') {
    if (stats.accountCount === 0) {
      return 'Accounts';
    }

    if (stats.accountCount === 1) {
      return '1 Account';
    }

    return `${stats.accountCount} Accounts`;
  }

  if (stats.violationCount === 0) {
    return 'Violations';
  }

  if (stats.violationCount === 1) {
    return '1 Violation';
  }

  return `${stats.violationCount} Violations`;
};

export default 'default_fn';
